import { Action } from 'redux';
import { IJsonQuery } from '../../../packages/api-models/common/json_query';

import { FILTERS_SET_JSON_QUERY_TYPE } from '../../constants/action_types';

export type TSetJsonQueryType = 'filters/set_json_query';

export interface ISetJsonQuery extends Action<TSetJsonQueryType> {
  type: TSetJsonQueryType;
  jsonQuery: IJsonQuery;
}

export type TSetJsonQuery = ISetJsonQuery;

export function setJsonQuery(jsonQuery: IJsonQuery): TSetJsonQuery {
  return {
    type: FILTERS_SET_JSON_QUERY_TYPE,
    jsonQuery,
  };
}
